export default "__VITE_ASSET__bee808f0__"